import BaseMask from "./_base.mask";

const MONTH_AND_YEAR_MASK = "99/9999";

const validateMonthAndYear = (monthAndYear = "") => {
  const exp = /\.|-|\//g;

  monthAndYear = monthAndYear.toString().replace(exp, "");

  if (monthAndYear === "" || monthAndYear.length !== 6) return false;

  if (
    monthAndYear === "000000" ||
    monthAndYear === "111111" ||
    monthAndYear === "222222" ||
    monthAndYear === "333333" ||
    monthAndYear === "444444" ||
    monthAndYear === "555555" ||
    monthAndYear === "666666" ||
    monthAndYear === "777777" ||
    monthAndYear === "888888" ||
    monthAndYear === "999999"
  )
    return false;

  let lengthMonthAndYear = monthAndYear.length;
  let month = monthAndYear.substring(0, 2);
  let year = monthAndYear.substring(2, lengthMonthAndYear);

  let yearToday = new Date().getFullYear();

  if (month > 12 || year < yearToday) return false;

  return true;
};

export class MonthAndYearMask extends BaseMask {
  static getType() {
    return "month-and-year";
  }

  getValue(value) {
    return this.getVMasker().toPattern(value, MONTH_AND_YEAR_MASK);
  }

  getRawValue(maskedValue) {
    return super.removeNotNumbers(maskedValue);
  }

  validate(value) {
    return validateMonthAndYear(value);
  }
}
